import React, {Component} from 'react';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import {CHECK__16} from '@homeaway/svg-defs';
import clientLogger from '../../utils/client-logger';
import {FormInput} from '@homeaway/react-form-components';
import {SVGIcon} from '@homeaway/react-svg';
import {withTranslationsAsProps} from '../translations';
import './copy-input.less';

export function selectRange($input) {
    if (
        !$input.setSelectionRange
        || !window.getSelection
        || !document.createRange
    ) {
        return null;
    }

    const range = document.createRange();
    const selection = window.getSelection();

    range.selectNodeContents($input);
    selection.removeAllRanges();
    selection.addRange(range);
    $input.setSelectionRange(0, $input.value.length);
    return selection;
}

export function removeRange(selection) {
    if (!selection || !selection.removeAllRanges) {
        return;
    }
    selection.removeAllRanges();
}

export class CopyInput extends Component {
    static defaultProps = {
        errorMsg: null,
        isMobile: false,
        onCopyClick: () => {},
        onCopyUrl: () => {},
        onCutUrl: () => {},
        value: ''
    }

    constructor(props) {
        super(props);
        this.formInput = {}; // <FormInput/> ref
        this.state = {
            isCopied: false
        };
    }

    handleCopyClick = () => {
        const {input} = this.formInput;
        const {isMobile, onCopyClick} = this.props;
        onCopyClick();
        if (!input) {
            return;
        }
        input.select();


        // SCRATCHPAD-2028 iOS needs range selectors for execCommand, this breaks in IE 11 so we only call them if isMobile
        const selection = isMobile ? selectRange(input) : null;

        try {
            const isCopied = document.execCommand('copy');
            this.setState({isCopied});
        } catch (e) {
            clientLogger.captureException(e);
        }

        if (selection) {
            removeRange(selection);
        }
    }

    render() {
        const {
            isCopied
        } = this.state;
        const {
            copiedText,
            copyText,
            errorMsg,
            onCopyUrl,
            onCutUrl,
            value,
            ...rest
        } = this.props;

        return (
            <div className="copy-input__container">
                <div className="input-group">
                    <div className="input-group-wrapper">
                        <FormInput
                            className="copy-input__form-group"
                            errorMsg={errorMsg}
                            inputClassName="copy-input__input"
                            label={copyText}
                            onCopy={onCopyUrl}
                            onCut={onCutUrl}
                            ref={(formInput) => (this.formInput = formInput)}
                            srOnlyLabel
                            value={value}
                            {...rest}
                        />
                    </div>
                    <span className="input-group-btn">
                        {isCopied &&
                            <ButtonPrimary
                                block
                                className="copy-input__btn"
                                label={copiedText}
                                onClick={this.handleCopyClick}
                            >
                                <SVGIcon className="copy-input__svg" markup={CHECK__16} />
                            </ButtonPrimary>
                        }
                        {!isCopied &&
                            <Button
                                block
                                className={`copy-input__btn grey ${errorMsg ? 'has-error' : ''}`}
                                disabled={!!errorMsg}
                                label={copyText}
                                onClick={this.handleCopyClick}
                            />
                        }
                    </span>
                </div>
            </div>
        );
    }
}

export default withTranslationsAsProps({
    'tripboards.copied': 'copiedText',
    'tripboards.copy': 'copyText'
})(CopyInput);



// WEBPACK FOOTER //
// ./src/universal/components/copy-input/copy-input.js